'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const NotesIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="NotesIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        id="Notes-Book-Text--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Notes Book Text Streamline Icon: https://streamlinehq.com</desc>
        <defs></defs>
        <path
          d="M3 2.5h18s1 0 1 1v19s0 1 -1 1H3s-1 0 -1 -1v-19s0 -1 1 -1"
          fill="none"
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m6 4.5 0 -4"
          fill="none"
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m18 4.5 0 -4"
          fill="none"
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m10 4.5 0 -4"
          fill="none"
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m14 4.5 0 -4"
          fill="none"
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m6 9.5 12 0"
          fill="none"
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m6 12.5 12 0"
          fill="none"
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m6 15.5 12 0"
          fill="none"
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m6 18.5 7 0"
          fill="none"
          stroke={sx?.color || '#333333'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

NotesIcon.propTypes = {
  sx: PropTypes.object
}
